import { render, staticRenderFns } from "./cv-form.vue?vue&type=template&id=0c85ac29&"
import script from "./cv-form.vue?vue&type=script&lang=js&"
export * from "./cv-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports